export default {
    apiKey: "AIzaSyBLl5kDYJ2s-Z_Khwrz4qOXPcZAkMy-L4M",
    authDomain: "sohookd-marketplace.firebaseapp.com",
    databaseURL: "https://sohookd-marketplace.firebaseio.com",
    projectId: "sohookd-marketplace",
    storageBucket: "sohookd-marketplace.appspot.com",
    messagingSenderId: "39745286871",
    recaptchaKey: '6LdN-o4UAAAAAJv6a59gmaxNwZf9Zhz__xCcZgRI'
};